import { render, staticRenderFns } from "./ChapterTab.vue?vue&type=template&id=7ee3fd59&scoped=true&"
import script from "./ChapterTab.vue?vue&type=script&lang=ts&"
export * from "./ChapterTab.vue?vue&type=script&lang=ts&"
import style0 from "./ChapterTab.vue?vue&type=style&index=0&id=7ee3fd59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee3fd59",
  null
  
)

export default component.exports